export const categories = [
    { name: "U11" },
    { name: "U13 MASCULINO" },
    { name: "U14 MASCULINO" },
    { name: "U14 FEMENINO" },
    // { name: "U15 MASCULINO" },
    // { name: "U15 FEMENINO" },
    { name: "U16 MASCULINO" },
    { name: "U16 FEMENINO" }
];